import type { EnumUnion } from "@dresscode-frontend/utility-types";
import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

// カラム名定数
export const Columns = {
  NAME: "NAME",
  TYPE: "TYPE",
  GENRE: "GENRE",
  MANUFACTURER: "MANUFACTURER",
  STATUS: "STATUS",
  ACTIVATED_DATE: "ACTIVATED_DATE",
  LAST_MODIFIED_DATE: "LAST_MODIFIED_DATE",
  ARCHIVED_DATE: "ARCHIVED_DATE",
  CATEGORY_ID: "CATEGORY_ID",
} as const;
export type Columns = EnumUnion<typeof Columns>;

// ソート対象の項目
export const OrderBy = {
  NAME: "NAME",
  ACTIVATED_DATE: "ACTIVATED_DATE",
  LAST_MODIFIED_DATE: "LAST_MODIFIED_DATE",
  ARCHIVED_DATE: "ARCHIVED_DATE",
} as const;
export type OrderBy = EnumUnion<typeof OrderBy>;

// カタログステータスフィルタ
export const CatalogStatusFilterKey = {
  ACTIVE: "ACTIVE",
  DRAFT: "DRAFT",
  ARCHIVED: "ARCHIVED",
  ALL: "ALL",
} as const;
export type CatalogStatusFilterKey = EnumUnion<typeof CatalogStatusFilterKey>;

// タブキー定義
export const TabKey = {
  ACTIVE: CatalogStatusFilterKey.ACTIVE,
  DRAFT: CatalogStatusFilterKey.DRAFT,
  ALL: CatalogStatusFilterKey.ALL,
  ARCHIVED: CatalogStatusFilterKey.ARCHIVED,
} as const;
export type TabKey = EnumUnion<typeof TabKey>;

export const TabKeySchema = z.nativeEnum(TabKey);

// 検索パラメータのZodスキーマ
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.nativeEnum(OrderBy).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  status: z.nativeEnum(CatalogStatusFilterKey).default(TabKey.ALL),
});
